export default __webpack_public_path__ + "static/media/arrow.a9241587.svg";